import React from 'react';
import { observer } from 'mobx-react-lite';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_TYPE } from '../../enums/cardTypes';
import { DARK_CARD_STATUS } from '../../enums/cardStatus';
import { gameStore } from '../../store/gameStore';

const DealerCards = observer(() => {
  const { dealerAnimationClassName, selectedCardBackSideType, selectedCardType } = cardsStore;
  const { dealerInsuranceAnimationStart } = gameStore;
  const {
    dealerCardsInfo: { cards, point, secondPoint },
  } = cardsStore;

  if (!cards) {
    return null;
  }
  return (
    <div className='tb-dealer'>
      <span className='tb-dealer-total-points'>
        {secondPoint ? `${secondPoint}/` : ''}
        {point}
      </span>
      {cards.map(({ card, index, status }, arrayIndex) => {
        return (
          // ToDo: Add class 'peep' to this el, to make it bend
          <div
            className={`tb-dealer-card deck-1 ${
              cards.length - 1 === arrayIndex ? dealerAnimationClassName : ''
            } ${cards.length - 1 === arrayIndex && dealerInsuranceAnimationStart ? 'peep' : ''}`}
            key={index}
          >
            <div
              className={`tb-card deck-1 cover-1 ${status !== DARK_CARD_STATUS ? 'open' : ''} ${
                CARDS_TYPE[card]
              }`}
            >
              <span className={`tb-card-front-side ${selectedCardType}`} />
              <span className={`tb-card-back-side ${selectedCardBackSideType}`} />
            </div>
          </div>
        );
      })}
    </div>
  );
});
export default DealerCards;
